import React from "react";
import styled from "styled-components/native";

import { useColorMode, themeTools, HStack } from "native-base"


export const Row = React.memo(({ level, ...props }) => {
    return <StyledRow colorMode={ useColorMode().colorMode } shadow={ level } { ...props } />
})


const StyledRow = styled(HStack).attrs((props) => ({
    shadow: props.shadow || undefined,
    space: props.space ?? 4,
    borderRadius: props.borderRadius ?? 8,
    borderColor: props.borderColor ?? "muted.100",
    padding: props.padding ?? (props.shadow ? 4 : undefined),
    backgroundColor: props.backgroundColor ?? (!props.shadow ? undefined : themeTools.mode("light.50", "dark.50")(props)),
    width: props.width ?? "100%",
}))`
    ${
        (props) => props.shadow !== 1 
            ?   ""
            :   `
                border-width: 2px;
                border-style: solid;
                box-shadow: none;
            `
    }
`;